module.exports = __webpack_public_path__ + "img/snp-editor.bce2d204.png";